import { render, staticRenderFns } from "./MediaGroupMediaView.vue?vue&type=template&id=622bf0a6&"
import script from "./MediaGroupMediaView.vue?vue&type=script&lang=js&"
export * from "./MediaGroupMediaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports